export const CATALOG_URL = '/catalog'
export const ROOT_URL = '/'
export const OUR_PLATFORM_URL = '/our-platform'
export const ADMIN_CATALOG_ITEM_URL = '/admin/catalog_items'
export const ITEM_UPLOAD_URL = '/items/new'
